import React from 'react'
import PropTypes from 'prop-types'
import {
  CONTENT_TYPES,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import SubjectHeader from '@components/SubjectHeader'
import Heading from '@components/Heading'
import BlockRenderer from '@views/BlockRenderer'

const SectionRenderer = (props) => {
  const { section, hideSubject = false } = props

  if (!section) return null

  return (
    <>
      <div className={'mx-auto max-w-[700px]'}>
        <div className={'flex flex-col'} id={'readspeaker-content'}>
          {!hideSubject && (
            <SubjectHeader
              subject={section.subject}
              type={CONTENT_TYPES.SECTION}
              dark
            />
          )}
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXXLARGE}>
            {section.name}
          </Heading>
        </div>
      </div>
      <BlockRenderer content={section.content} />
    </>
  )
}

SectionRenderer.propTypes = {
  section: PropTypes.object,
  hideSubject: PropTypes.bool,
}

export default SectionRenderer
